import React, { useEffect } from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import PropTypes from 'prop-types';
import { ProgressCircle } from '@americanexpress/dls-react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';

import childRoutes from '../childRoutes';

import '../styles/index.scss';

const AxpDigitalCredentialsRoot = ({
  languageData, locale, children, location,
}) => {
  const dispatch = useDispatch();
  const activeLocale = useSelector((state) => state.getIn(['intl', 'activeLocale']));
  const axpStaticUrl = useSelector((state) => state.getIn(['config', 'axpStaticUrl']));

  useEffect(() => {
    dispatch(loadLanguagePack('axp-digital-credentials-root', { fallbackLocale: 'en-US' }));
  }, [activeLocale, dispatch]);

  if (Object.entries(languageData).length === 0) {
    return (
      <div className={location.pathname.includes('wallet') ? 'dls-deep-blue-bg' : ''}>
        <ProgressCircle />
      </div>
    );
  }

  return (
    <IntlProvider locale={locale} messages={languageData}>
      <FormattedMessage id="helmet.title">
        {(title) => (
          <Helmet>
            <html lang={locale} />
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <title>{title}</title>
            <link rel="stylesheet" href="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.25.5/package/dist/6.25.5/styles/dls.min.css" />
            <link rel="icon" href="https://www.americanexpress.com/favicon.ico" />
            <link rel="preconnect" href={axpStaticUrl} />
          </Helmet>
        )}
      </FormattedMessage>
      {children}
    </IntlProvider>
  );
};

export const TestableAxpDigitalCredentialsRoot = AxpDigitalCredentialsRoot;

AxpDigitalCredentialsRoot.propTypes = {
  languageData: PropTypes.shape({}).isRequired, // no need to restate all the keys in the lang pack
  locale: PropTypes.string.isRequired,
  children: PropTypes.node,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

// Read about childRoutes:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/Routing.md#childroutes
AxpDigitalCredentialsRoot.childRoutes = childRoutes;

// Read about appConfig:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/App-Configuration.md
/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line global-require -- require needs to be inside browser check
  AxpDigitalCredentialsRoot.appConfig = require('../appConfig').default;
}

export const loadModuleData = ({ store: { dispatch } }) => dispatch(
  loadLanguagePack('axp-digital-credentials-root', {
    fallbackLocale: 'en-US',
  })
);

AxpDigitalCredentialsRoot.holocron = {
  name: 'axp-digital-credentials-root',
  loadModuleData,
};

export default oneAppModuleWrapper('axp-digital-credentials-root')(
  AxpDigitalCredentialsRoot
);
